<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="onUpdateModelValue"
    v-bind="$attrs"
    @click:outside="onClickOutside"
  >
    <slot />
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { VDialog } from 'vuetify/components';

export default defineComponent({
  name: 'UIVDialog',
  components: { VDialog },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'click:outside'],
  methods: {
    onUpdateModelValue(value: boolean) {
      this.$emit('update:modelValue', value);
    },
    onClickOutside(event: Event) {
      this.$emit('click:outside', event);
    },
  },
});
</script>
